import { render, staticRenderFns } from "./CreateAdditionalReferralModal.vue?vue&type=template&id=12d077a4&"
import script from "./CreateAdditionalReferralModal.vue?vue&type=script&lang=ts&"
export * from "./CreateAdditionalReferralModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports